import React, { useEffect, useState } from "react";
import { Button, Col, Row } from "reactstrap";
import moment from "moment";
import { formatNumber } from "../../../Utils/Money";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Input from "@material-ui/core/Input";
import { FormHelperText, IconButton } from "@material-ui/core";
import { Field, reduxForm, change } from "redux-form";
import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";
import AlertModal from "../../../../shared/components/Modal";
import { PrintRefunds } from "./PrintRefunds";
import Modal from "@material-ui/core/Modal";
import CloseIcon from "@material-ui/icons/Close";
import { useDispatch } from "react-redux";
import RefundsList from "./RefundsList";
import RefundsListActions from "./RefundsListActions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DigitalSignature from "../../../DigitalSignature/DigitalSignature";
import { faFileSignature } from "@fortawesome/free-solid-svg-icons";

const styles = (theme) => ({
  date: {
    width: 400,
    fontFamily: "Roboto",
    border: "none",
    fontSize: 13,
  },
});

const ModalRefunds = ({ admision, closeModal, receipt }) => {
  const dispatch = useDispatch();
  const dateReceipt = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
  const [reasonRefunds, setReasonRefunds] = useState("");
  const [valueRefunds, setValueRefunds] = useState("");
  const [errors, setErrors] = useState({});
  const [maximumValue, setMaximumValue] = useState(null);
  const [showAlertModal, setShowAlertModal] = React.useState(false);
  const [colorAlertModal, setAlertColorModal] = React.useState("");
  const [messagAlerteModal, setAlertMessageModal] = React.useState(null);
  const [openModalImprimir, setOpenModalImprimir] = useState(false);
  const [refunds, setRefunds] = useState([]);
  const [patientSignature, setPatientSignature] = React.useState(null);
  const [openSignaturePatient, setOpenSignaturePatient] = React.useState(null);
  

  useEffect(() => {
    consultarValorMaximo();
    loadRefundsRecibo();
  }, []);

  async function loadRefundsRecibo() {
    const recibo = {
      id_recibo: receipt.id_recibo,
    };
    const respuesta = await fetch(
      process.env.REACT_APP_PUBLIC_URL + `devolucion-recibo-caja/consultar`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(recibo),
      }
    );
    const data = await respuesta.json();
    setRefunds(data);
  }

  const printRefundsData = () => {
    setOpenModalImprimir(true);
    PrintRefunds({receipt, admision, patientSignature});
  };

  const totalDevolucion = receipt.medio_pago.medio[0].monto - maximumValue;

  const handleReasonRefunds = (refunds) => {
    setReasonRefunds(refunds);
  };

  const handleValueRefunds = (valor) => {
    if (valor === "") {
      setValueRefunds(null);
      return;
    }
    let parseValue = parseInt(valor);

    setValueRefunds(parseValue);
    if (parseValue <= totalDevolucion) {
      setErrors({ ...errors, valueRefunds: "" });
    } else {
      setErrors({ ...errors, valueRefunds: "Ingrese un valor menor al total" });
    }
  };

  const validation = () => {
    var errors = {};
    var error = false;
    if (reasonRefunds === "") {
      errors.reasonRefunds = "Ingrese el motivo";
      error = true;
    }

    if (valueRefunds === "" || valueRefunds === null) {
      errors.valueRefunds = "Ingrese el valor de la devolución";
      error = true;
    }

    if (valueRefunds > totalDevolucion) {
      errors.valueRefunds = "Ingrese un valor menor al total";
      error = true;
    }

    setErrors(errors);
    return error;
  };

  let usuario =
    sessionStorage.getItem("usuario") != undefined &&
    sessionStorage.getItem("usuario") != null
      ? sessionStorage.getItem("usuario")
      : null;
  let id_usuario = usuario != null ? JSON.parse(usuario).id_usuario : null;

  const createRefunds = () => {
    if (!validation()) {
      if(patientSignature == null){
        setShowAlertModal(true);
        setAlertColorModal("danger");
        setAlertMessageModal("No puede generar una devolución del recibo de caja sin la firma del Paciente");
        return;
      }
      var data = {
        fecha_emision: dateReceipt,
        id_recibo: receipt.id_recibo,
        id_admision: admision.id_admision,
        motivo_devolucion: reasonRefunds,
        valor_devolucion: valueRefunds,
        id_usuario: id_usuario,
        firma_digital: patientSignature,
      };
      fetch(
        process.env.REACT_APP_PUBLIC_URL + "devolucion-recibo-caja/create",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: "Bearer " + sessionStorage.getItem("token"),
          },
          body: JSON.stringify(data),
        }
      )
        .then((response) => {
          setShowAlertModal(true);
          setAlertColorModal("success");
          setAlertMessageModal("Devolución realizada correctamente");
          consultarValorMaximo();
          dispatch(change("modal-refunds", "textarea-reason-refunds", ""));
          setValueRefunds("");
          setPatientSignature(null);
          loadRefundsRecibo();
          console.log("Respuesta", response.json());
          return response.json();
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }
  };

  async function consultarValorMaximo() {
    const recibo = {
      id_recibo: receipt.id_recibo,
    };
    const respuesta = await fetch(
      process.env.REACT_APP_PUBLIC_URL +
        `devolucion-recibo-caja/consultarValorMaximo`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(recibo),
      }
    );
    const data = await respuesta.json();
    setMaximumValue(data);
  }

  return (
    <>
      <div className="subtitle-general">
        <h4 style={{ marginLeft: 12 }}>Devoluciones</h4>
      </div>

      <div>
        <Row style={{ marginTop: 15 }}>
          <Col md={4}>
            <div className="element-inside-row">
              <b>Fecha:</b> {dateReceipt}
            </div>
          </Col>
          <Col md={8}>
            <div className="element-inside-row">
              <b>Número del recibo:</b> {receipt.num_recibo}
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <div className="element-inside-row">
              <b>Número de documento:</b> {admision.num_documento}
            </div>
          </Col>
          <Col md={8}>
            <div className="element-inside-row">
              <b>Nombre del paciente:</b> {admision.fullname}
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <div className="element-inside-row">
              <b>Forma de pago:</b> {receipt.medio_pago.medio[0].medio}
            </div>
          </Col>
          <Col md={8}>
            <div className="element-inside-row">
              <b>Total:</b> ${formatNumber(totalDevolucion)}
            </div>
          </Col>
        </Row>
        {receipt.estado === 1 ? (
          <div>
            <Row>
              <Col md={12}>
                <div className="element-inside-row" style={{ marginTop: 15 }}>
                  <b>Motivo de la devolución</b>
                  <Field
                    name="textarea-reason-refunds"
                    component="textarea"
                    value={reasonRefunds}
                    onChange={(e) => {
                      handleReasonRefunds(
                        e.target.value.replace(/(\r\n|\n|\r)/gm, " ")
                      );
                    }}
                    style={{ width: "100%" }}
                  />
                  <FormHelperText
                    style={{ color: "#d50000", fontWeight: "bold" }}
                  >
                    {errors.hasOwnProperty("reasonRefunds")
                      ? errors.reasonRefunds
                      : ""}
                  </FormHelperText>
                </div>
              </Col>
            </Row>
            <Row>
              <div className="element-inside-row" style={{ marginTop: 15 }}>
                <FormControl>
                  <InputLabel htmlFor="standard-adornment-amount">
                    Valor de la devolución
                  </InputLabel>
                  <Input
                    id="standard-adornment-amount"
                    value={valueRefunds}
                    type="number"
                    onChange={(e) => handleValueRefunds(e.target.value)}
                    error={
                      errors.hasOwnProperty("valueRefunds")
                        ? errors.valueRefunds !== ""
                        : false
                    }
                  />
                  <FormHelperText>
                    {errors.hasOwnProperty("valueRefunds") ? (
                      <b className="text-danger">{errors.valueRefunds}</b>
                    ) : (
                      ""
                    )}
                  </FormHelperText>
                </FormControl>
              </div>
            </Row>
            <br />
              {patientSignature != null ? (
                <img style={{ width: 90, height: 40, marginLeft: 8 }} src={patientSignature} />
              ) : null}
            <Row>
              <Col md={4}>
                <div className="element-inside-row">
                  <Button
                    style={{ marginTop: 30 }}
                    color="primary"
                    size="sm"
                    //disabled={disabledText}
                    onClick={() => {
                      setOpenSignaturePatient(true);
                    }}
                  >
                    <FontAwesomeIcon icon={faFileSignature} /> Firma del
                    Paciente
                  </Button>
                  <DigitalSignature
                    openModalSignature={openSignaturePatient}
                    closeModalSignature={() => setOpenSignaturePatient(false)}
                    confirmSign={(value) => {
                      setPatientSignature(value);
                    }}
                    signature={patientSignature}
                  />
                </div>
              </Col>
            </Row>
          </div>
        ) : null}
      </div>
      <RefundsList
        refunds={refunds}
        receipt={receipt}
        ReactTableActions={RefundsListActions}
        admision={admision}
        refreshList={loadRefundsRecibo}
      />

      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <Button
          style={{ marginTop: 20 }}
          size="sm"
          onClick={() => {
            closeModal();
          }}
        >
          Cerrar
        </Button>

        {receipt.estado === 1 ? (
          <Button
            style={{ marginTop: 20, marginLeft: 5 }}
            color="primary"
            size="sm"
            onClick={() => {
              createRefunds();
            }}
          >
            Guardar
          </Button>
        ) : null}

        <Button
          style={{ marginTop: 20, marginLeft: 5 }}
          color="primary"
          size="sm"
          onClick={() => {
            printRefundsData();
          }}
        >
          Imprimir
        </Button>
      </div>
      <AlertModal
        color={colorAlertModal}
        title={messagAlerteModal}
        modal={showAlertModal}
        onOk={() => {
          switch (colorAlertModal) {
            case "success":
              setShowAlertModal(false);
              setAlertColorModal("success");
              setAlertMessageModal("");
            break;
            case "danger":
              setShowAlertModal(false);
              setAlertColorModal("danger");
            break;
          }
        }}
        toggle={() => {
          setShowAlertModal(false);
          switch (colorAlertModal) {
            case "success":
              setAlertColorModal("success");
              setAlertMessageModal("");
              break;
          }
        }}
      />
      <Modal
        open={openModalImprimir}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        style={{ zIndex: 1000 }}
      >
        <div
          className="paperAppointment-flex"
          style={{ width: "120%", margin: 10 }}
        >
          <IconButton
            style={{ float: "right" }}
            onClick={() => {
              setOpenModalImprimir(false);
            }}
          >
            <CloseIcon />
          </IconButton>
          <iframe id="pdfV" width="1000" height="600"></iframe>
        </div>
      </Modal>
    </>
  );
};

export default reduxForm({
  form: "modal-refunds", // a unique identifier for this form
})(
  withStyles(styles, { withTheme: true })(
    withTranslation("common")(ModalRefunds)
  )
);
